/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentLabelMembersRequest
} from './model/agentLabelMembersRequest.js';

import type {
  AgentLabelResponse
} from './model/agentLabelResponse.js';

import type {
  CreateAgentLabelRequest
} from './model/createAgentLabelRequest.js';

import type {
  ListAgentLabelsResponse
} from './model/listAgentLabelsResponse.js';

import type {
  UpdateAgentLabelRequest
} from './model/updateAgentLabelRequest.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the agent labels in the active organization.
 */
export const listAgentLabels = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAgentLabelsResponse>(
      {url: `/agent-labels`, method: 'GET', signal
    },
      options);
    }




export const getListAgentLabelsQueryKey = () => {
    return [
    `/agent-labels`
    ] as const;
    }


export const getListAgentLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentLabels>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentLabels>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentLabelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentLabels>>> = ({ signal }) => listAgentLabels(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentLabels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgentLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentLabels>>>
export type ListAgentLabelsQueryError = unknown


/**
 * @summary List the agent labels in the active organization.
 */

export function useListAgentLabels<TData = Awaited<ReturnType<typeof listAgentLabels>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentLabels>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgentLabelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create an agent label, optionally applying it straight away.
 */
export const createAgentLabel = (
    createAgentLabelRequest: CreateAgentLabelRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentLabelResponse>(
      {url: `/agent-labels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgentLabelRequest, signal
    },
      options);
    }




export const getCreateAgentLabelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentLabel>>, TError,{data: CreateAgentLabelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgentLabel>>, TError,{data: CreateAgentLabelRequest}, TContext> => {

const mutationKey = ['createAgentLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgentLabel>>, {data: CreateAgentLabelRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAgentLabel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgentLabelMutationResult = NonNullable<Awaited<ReturnType<typeof createAgentLabel>>>
    export type CreateAgentLabelMutationBody = CreateAgentLabelRequest
    export type CreateAgentLabelMutationError = unknown

    /**
 * @summary Create an agent label, optionally applying it straight away.
 */
export const useCreateAgentLabel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentLabel>>, TError,{data: CreateAgentLabelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgentLabel>>,
        TError,
        {data: CreateAgentLabelRequest},
        TContext
      > => {
      return useMutation(getCreateAgentLabelMutationOptions(options));
    }
    /**
 * @summary Rename an agent label or reword its description.
 */
export const updateAgentLabel = (
    labelId: string,
    updateAgentLabelRequest: UpdateAgentLabelRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentLabelResponse>(
      {url: `/agent-labels/${encodeURIComponent(String(labelId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAgentLabelRequest, signal
    },
      options);
    }




export const getUpdateAgentLabelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentLabel>>, TError,{labelId: string;data: UpdateAgentLabelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgentLabel>>, TError,{labelId: string;data: UpdateAgentLabelRequest}, TContext> => {

const mutationKey = ['updateAgentLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgentLabel>>, {labelId: string;data: UpdateAgentLabelRequest}> = (props) => {
          const {labelId,data} = props ?? {};

          return  updateAgentLabel(labelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentLabelMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgentLabel>>>
    export type UpdateAgentLabelMutationBody = UpdateAgentLabelRequest
    export type UpdateAgentLabelMutationError = unknown

    /**
 * @summary Rename an agent label or reword its description.
 */
export const useUpdateAgentLabel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentLabel>>, TError,{labelId: string;data: UpdateAgentLabelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgentLabel>>,
        TError,
        {labelId: string;data: UpdateAgentLabelRequest},
        TContext
      > => {
      return useMutation(getUpdateAgentLabelMutationOptions(options));
    }
    /**
 * @summary Delete an agent label and strip it from every agent.
 */
export const deleteAgentLabel = (
    labelId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/agent-labels/${encodeURIComponent(String(labelId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAgentLabelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentLabel>>, TError,{labelId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgentLabel>>, TError,{labelId: string}, TContext> => {

const mutationKey = ['deleteAgentLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgentLabel>>, {labelId: string}> = (props) => {
          const {labelId} = props ?? {};

          return  deleteAgentLabel(labelId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgentLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgentLabel>>>

    export type DeleteAgentLabelMutationError = unknown

    /**
 * @summary Delete an agent label and strip it from every agent.
 */
export const useDeleteAgentLabel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentLabel>>, TError,{labelId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgentLabel>>,
        TError,
        {labelId: string},
        TContext
      > => {
      return useMutation(getDeleteAgentLabelMutationOptions(options));
    }
    /**
 * @summary Apply a label to agents.
 */
export const addAgentLabelMembers = (
    labelId: string,
    agentLabelMembersRequest: AgentLabelMembersRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentLabelResponse>(
      {url: `/agent-labels/${encodeURIComponent(String(labelId))}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agentLabelMembersRequest, signal
    },
      options);
    }




export const getAddAgentLabelMembersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext> => {

const mutationKey = ['addAgentLabelMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAgentLabelMembers>>, {labelId: string;data: AgentLabelMembersRequest}> = (props) => {
          const {labelId,data} = props ?? {};

          return  addAgentLabelMembers(labelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAgentLabelMembersMutationResult = NonNullable<Awaited<ReturnType<typeof addAgentLabelMembers>>>
    export type AddAgentLabelMembersMutationBody = AgentLabelMembersRequest
    export type AddAgentLabelMembersMutationError = unknown

    /**
 * @summary Apply a label to agents.
 */
export const useAddAgentLabelMembers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addAgentLabelMembers>>,
        TError,
        {labelId: string;data: AgentLabelMembersRequest},
        TContext
      > => {
      return useMutation(getAddAgentLabelMembersMutationOptions(options));
    }
    /**
 * @summary Remove a label from agents.
 */
export const removeAgentLabelMembers = (
    labelId: string,
    agentLabelMembersRequest: AgentLabelMembersRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentLabelResponse>(
      {url: `/agent-labels/${encodeURIComponent(String(labelId))}/members`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: agentLabelMembersRequest, signal
    },
      options);
    }




export const getRemoveAgentLabelMembersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext> => {

const mutationKey = ['removeAgentLabelMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAgentLabelMembers>>, {labelId: string;data: AgentLabelMembersRequest}> = (props) => {
          const {labelId,data} = props ?? {};

          return  removeAgentLabelMembers(labelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAgentLabelMembersMutationResult = NonNullable<Awaited<ReturnType<typeof removeAgentLabelMembers>>>
    export type RemoveAgentLabelMembersMutationBody = AgentLabelMembersRequest
    export type RemoveAgentLabelMembersMutationError = unknown

    /**
 * @summary Remove a label from agents.
 */
export const useRemoveAgentLabelMembers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgentLabelMembers>>, TError,{labelId: string;data: AgentLabelMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeAgentLabelMembers>>,
        TError,
        {labelId: string;data: AgentLabelMembersRequest},
        TContext
      > => {
      return useMutation(getRemoveAgentLabelMembersMutationOptions(options));
    }
